// ============================================================================
// CHECK-IN ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/CheckIn';

export const checkInEndpoints = {
  /** POST /api/v1/CheckIn/{bookingId} — performs the Quick Check-In. */
  checkIn: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:bookingId`, { bookingId }),
  /** PUT /api/v1/CheckIn/{bookingId} — amends the check-in while CHECKED_IN. */
  amend: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:bookingId`, { bookingId }),
  /** POST /api/v1/CheckIn/{bookingId}/change-request — request-only FO ask to booking staff. */
  changeRequest: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:bookingId/change-request`, { bookingId }),
  /** POST /api/v1/CheckIn/{bookingId}/no-show */
  markNoShow: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:bookingId/no-show`, { bookingId }),
  /** POST /api/v1/CheckIn/{bookingId}/no-show-rooms — room-level no-show on a partially-arrived booking. */
  markNoShowRooms: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:bookingId/no-show-rooms`, { bookingId }),
  /** GET /api/v1/CheckIn/by-booking/{bookingId} */
  getByBooking: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-booking/:bookingId`, { bookingId }),
  /** GET /api/v1/CheckIn/available-rooms?propertyId=…&roomCategoryId=…&checkInDate=… */
  availableRooms: () => buildEndpoint(`${BASE_PATH}/available-rooms`),
  /** GET /api/v1/CheckIn/{bookingId}/inventory-impact — nightly position per category across the stay. */
  inventoryImpact: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:bookingId/inventory-impact`, { bookingId }),
} as const;

export default checkInEndpoints;
